import { MarketingShell } from "@/components/landing/MarketingShell";
import { FAQ, faqs } from "@/components/landing/FAQ";
import { SeoHead } from "@/components/useSeo";

const generateStructuredMarkup = () => {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map(faq => ({
      "@type": "Question",
      name: faq.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: faq.answer
      }
    }))
  };
};

function Page() {
  const jsonLd = generateStructuredMarkup();

  return (
    <>
      <SeoHead path="faq">
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(jsonLd).replace(/</g, "\\u003c")
          }}
        />
      </SeoHead>

      <MarketingShell className="flex flex-col justify-center">
        <section className="container py-20">
          <FAQ />
        </section>
      </MarketingShell>
    </>
  );
}

export default Page;
